import { isDateAfter, isDateBefore } from 'odfjell-date-time-utils/dateTimeUtils';
import { EventTypeGroup } from '../../types/ViewModel/EventTypeGroup';
import { EventTypeGroupConfigChange } from '../../types/ViewModel/EventTypeGroupConfigChange';

export default () => {
    const isAfter = (from: Date | null, firstEvTimeInPortCall: Date): boolean => {
        if (!from) return true;
        return isDateAfter(firstEvTimeInPortCall, from);
    };

    const isBefore = (to: Date | null, firstEvTimeInPortCall: Date): boolean => {
        if (!to) return true;
        return isDateBefore(firstEvTimeInPortCall, to);
    };

    const isNull = (val: boolean | null): boolean => {
        if (val === null) return true;
        return false;
    };

    const getEventTypeGroupConfigChange = (evTypeGroup: EventTypeGroup, firstEvTimeInPortCall: Date): EventTypeGroupConfigChange | null => {
        const evTypeGrCfgChangeList = evTypeGroup.eventTypeGroupConfigChangeList.filter((o) => {
            if (isAfter(o.from, firstEvTimeInPortCall!) && isBefore(o.to, firstEvTimeInPortCall!)) {
                return true;
            }
            return false;
        });
        if (evTypeGrCfgChangeList && evTypeGrCfgChangeList.length === 1) {
            return evTypeGrCfgChangeList[0];
        }
        return null;
    };

    const isMandatory = (evTypeGroup: EventTypeGroup, firstEvTimeInPortCall: Date | null): boolean => {
        if (firstEvTimeInPortCall) {
            const evTypeGrCfgChange = getEventTypeGroupConfigChange(evTypeGroup, firstEvTimeInPortCall!);
            if (evTypeGrCfgChange && !isNull(evTypeGrCfgChange.mandatory)) {
                return Boolean(evTypeGrCfgChange.mandatory);
            }
        }
        return evTypeGroup.mandatory;
    };

    const isMultiple = (evTypeGroup: EventTypeGroup, firstEvTimeInPortCall: Date | null): boolean => {
        if (firstEvTimeInPortCall) {
            const evTypeGrCfgChange = getEventTypeGroupConfigChange(evTypeGroup, firstEvTimeInPortCall!);
            if (evTypeGrCfgChange) {
                return Boolean(evTypeGrCfgChange.multiple);
            }
        }
        return evTypeGroup.multiple;
    };

    const isConcurrent = (evTypeGroup: EventTypeGroup, firstEvTimeInPortCall: Date | null): boolean => {
        if (firstEvTimeInPortCall) {
            const evTypeGrCfgChange = getEventTypeGroupConfigChange(evTypeGroup, firstEvTimeInPortCall!);
            if (evTypeGrCfgChange) {
                return Boolean(evTypeGrCfgChange.concurrent);
            }
        }
        return evTypeGroup.concurrent;
    };

    const isOrdered = (evTypeGroup: EventTypeGroup, firstEvTimeInPortCall: Date | null): boolean => {
        if (firstEvTimeInPortCall) {
            const evTypeGrCfgChange = getEventTypeGroupConfigChange(evTypeGroup, firstEvTimeInPortCall!);
            if (evTypeGrCfgChange) {
                return Boolean(evTypeGrCfgChange.ordered);
            }
        }
        return evTypeGroup.ordered;
    };

    const getRequiredPreviousTypeId = (evTypeGroup: EventTypeGroup, firstEvTimeInPortCall: Date | null): number | null => {
        if (firstEvTimeInPortCall) {
            const evTypeGrCfgChange = getEventTypeGroupConfigChange(evTypeGroup, firstEvTimeInPortCall!);
            if (
                evTypeGrCfgChange &&
                (Boolean(evTypeGrCfgChange.requiredPreviousTypeId) ||
                    (!evTypeGrCfgChange.requiredPreviousTypeId && evTypeGrCfgChange.requiredPreviousTypeIdForceNull))
            ) {
                return evTypeGrCfgChange.requiredPreviousTypeId;
            }
        }
        return evTypeGroup.requiredPreviousTypeId;
    };

    const getRequiredPreviousSameTypeId = (evTypeGroup: EventTypeGroup, firstEvTimeInPortCall: Date | null): number | null => {
        if (firstEvTimeInPortCall) {
            const evTypeGrCfgChange = getEventTypeGroupConfigChange(evTypeGroup, firstEvTimeInPortCall!);
            if (
                evTypeGrCfgChange &&
                (Boolean(evTypeGrCfgChange.requiredPreviousSameTypeId) ||
                    (!evTypeGrCfgChange.requiredPreviousSameTypeId && evTypeGrCfgChange.requiredPreviousSameTypeIdForceNull))
            ) {
                return evTypeGrCfgChange.requiredPreviousSameTypeId;
            }
        }
        return evTypeGroup.requiredPreviousSameTypeId;
    };

    const getNotAfterEventTypeId = (evTypeGroup: EventTypeGroup, firstEvTimeInPortCall: Date | null): number | null => {
        if (firstEvTimeInPortCall) {
            const evTypeGrCfgChange = getEventTypeGroupConfigChange(evTypeGroup, firstEvTimeInPortCall!);
            if (
                evTypeGrCfgChange &&
                (Boolean(evTypeGrCfgChange.notAfterEventTypeId) ||
                    (!evTypeGrCfgChange.notAfterEventTypeId && evTypeGrCfgChange.notAfterEventTypeIdForceNull))
            ) {
                return evTypeGrCfgChange.notAfterEventTypeId;
            }
        }
        return evTypeGroup.notAfterEventTypeId;
    };

    const getEnabledFrom = (evTypeGroup: EventTypeGroup, firstEvTimeInPortCall: Date | null): Date | null => {
        if (firstEvTimeInPortCall) {
            const evTypeGrCfgChange = getEventTypeGroupConfigChange(evTypeGroup, firstEvTimeInPortCall!);
            if (
                evTypeGrCfgChange &&
                (Boolean(evTypeGrCfgChange.enabledFrom) || (!evTypeGrCfgChange.enabledFrom && evTypeGrCfgChange.enabledFromForceNull))
            ) {
                return evTypeGrCfgChange.enabledFrom;
            }
        }
        return evTypeGroup.enabledFrom;
    };

    const isDeleted = (evTypeGroup: EventTypeGroup, firstEvTimeInPortCall: Date | null): boolean => {
        if (firstEvTimeInPortCall) {
            const evTypeGrCfgChange = getEventTypeGroupConfigChange(evTypeGroup, firstEvTimeInPortCall!);
            if (evTypeGrCfgChange) {
                return Boolean(evTypeGrCfgChange.deleted);
            }
        }
        return evTypeGroup.deleted;
    };

    return {
        isMandatory,
        isMultiple,
        isConcurrent,
        isOrdered,
        getRequiredPreviousTypeId,
        getRequiredPreviousSameTypeId,
        getNotAfterEventTypeId,
        getEnabledFrom,
        isDeleted,
    };
};
